// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_90E","icon":"styles_icon__2BsJO"};